import { createContext, useContext } from "react";
import type { Config } from ".";

const ConfigContext = createContext<Config | null>(null);

interface Props {
  children: React.ReactNode;
  config: Config;
}

export function ConfigProvider({ children, config }: Props) {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within ConfigProvider");
  }
  return context;
}
